module.exports = __webpack_public_path__ + "static/media/savest-img.15bcbc9f.jpg";